import Slideshow from '../../../components/base/Slideshow';
import Button from '../../../components/base/Button';
import { slideshowData } from '../../../mocks/slideshow';

export default function HeroSection() {
  return (
    <section id="home" className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Content */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Excellence in{' '}
            <span className="text-blue-600">Dental Manufacturing</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-4xl mx-auto">
            Leading provider of precision dental devices and laboratory services, 
            trusted by dental professionals throughout the Pacific Northwest and United States for exceptional quality and innovation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              size="lg"
            >
              Explore Our Services
            </Button>
          </div>
        </div>

        {/* Slideshow */}
        <div className="mb-16">
          <Slideshow slides={slideshowData} />
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-microscope-line text-2xl text-blue-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3">Precision Manufacturing</h3>
            <p className="text-gray-600">State-of-the-art equipment ensures every device meets the highest quality standards.</p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-blue-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3">Fast Turnaround</h3>
            <p className="text-gray-600">Quick delivery without compromising quality, keeping your practice running smoothly.</p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-2xl text-blue-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3">Expert Support</h3>
            <p className="text-gray-600">Dedicated support team to assist with orders, technical questions, and consultations.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
